<template>
    <div>
        <b-table 
            responsive
            :fields="fields" 
            striped hover  
            :items="items">
            <template v-slot:cell(item_data)="data">
                <b-row>
                    <b-col class="col-sm-2 d-none d-sm-block">
                        <b-img :src="data.item.item_data.imagen" alt="Image 1" style="max-width: 100%; max-height: 100px; object-fit: scale-down;"></b-img>
                    </b-col>
                    <b-col cols="12" md="9">
                        <div>
                            {{ data.item.item_data.nombre }}
                        </div>
                        <div>
                            <b>Item:</b> {{ data.item.item_data.codigo }}
                        </div>
                    </b-col>
                </b-row>
            </template>
            <template v-slot:cell(precio)="data">
                $ {{numberFormat(data.item.precio)}}
            </template>
            <template v-slot:cell(item_id)="data">
                {{ data.item.item_data.categoria }}
            </template>
            <template v-slot:cell(actions)="{ item }">
                <b-button variant="info" v-b-tooltip.hover title="Editar precio" class="text-white" 
                @click.prevent="changePriceModal(item)">
                    <b-icon icon="pencil"></b-icon>
                </b-button>
                
            </template>
        </b-table>
        <template v-if="items.length < 1">
            <b-alert show variant="danger">
                Lo sentimos, no se han encontrado items asignados a esta lista de precios.
            </b-alert>
        </template>
        <b-container>
            <b-row class="justify-content-md-center">
                <b-col cols="12" md="6">
                    <b-pagination 
                        size="md" 
                        pills 
                        :total-rows="paginator.totalPage" 
                        v-model="paginator.page" 
                        :per-page="1" 
                        @input="changePage" 
                        first-number 
                        last-number>
                    </b-pagination>
                </b-col>
                <b-col cols="12" sm="2">
                    <b-form-select @change="updatePageSize()" v-model="paginator.pageSize" :options="pageSize" ></b-form-select>
                </b-col>
            </b-row>
        </b-container>
        <div v-if="openModal">
            <UpdateItemPriceModal 
                :updatePriceData="updatePriceData"
                title="Actualizar Precio"
                :openModal="openModal"
                @close-modal="closeUpdatePriceModal()"
                @confirm-update="changePriceRequest()"
             />
        </div>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'
import UpdateItemPriceModal from './UpdateItemPriceModal.vue'
export default {
    name: "ItemsComponent",
    props: {
        items: {
            type: Array
        },
        paginator: {
            type: Object
        },
        pageSize: {
            type: Array
        },
        idPricelist:{
            type: Number
        }
    },
    components: {
        UpdateItemPriceModal
    },
    data(){
        return{
            updatePriceModal: false,
            updatePriceData: {},
            fields: [
                { key: 'item_data', label: 'Item', sortable: true},
                { key: 'precio', label: 'Precio', sortable: true},
                { key: 'item_id', label: 'Categoría', sortable: true},
                { key: 'actions', label: 'Acciones'},
            ],
            openModal: false
        }
    },
    methods: {
        ...mapMutations(['setLoading']),
        updatePageSize(){
            /* the page sizee return the current page to initial because we can't know if the current page have items asigned!! */
            this.paginator.page = 1;
            /* emit the page size update to get the new list of items*/
            this.$emit('get-price-list-data-empresa');
        },
        changePage(){
            this.$emit('change-page', this.paginator.page);            
        },
        changePriceModal(item){
            this.openModal = true;
            this.updatePriceData = item;
        },
        closeUpdatePriceModal(){
            this.openModal = false;
            this.updatePriceData = {};
        },
        async changePriceRequest(){
            this.openModal = false;
            let priceListId = this.idPricelist;
            let item_id = this.updatePriceData.item_id;
            let precio = this.updatePriceData.precio;
            let data = {priceListId, item_id, precio}
            this.setLoading(true)
            await this.$conectar.post('/empresa/price-list/change-item-price', data)
            .then(response =>{
                this.$root.$bvToast.toast(response.data.message, {
                    title: "Respuesta del servidor",
                    variant: "success",
                    solid: true
                })
            })
            .catch(e => {
                console.log(e.response);
                this.$root.$bvToast.toast('Parece que hubo un error en el servidor', {
                    title: "Respuesta del servidor",
                    variant: "danger",
                    solid: true
                })
            })
            this.setLoading(false)
            //this.getPriceListData();
        },

    }
};

</script>
<style scoped>
</style>
